import { euDev, euProd, usDev, usProd } from "./regionHosts";

const REGION_COOKIE_NAME = "region";
export const isDev = typeof window !== "undefined" && window.location.hostname.includes("dev");
const MAX_AGE_DAYS = 30;

export const getRegionFromHostname = () => {
   const hostname = window.location.hostname;
   if (hostname === euProd || hostname === euDev) return "eu";
   if (hostname === usProd || hostname === usDev) return "us";
   return "us";
};

export const getRegionFromCookie = () => {
   if (typeof document === "undefined") return "us";

   const cookies = document.cookie.split("; ");
   for (const cookie of cookies) {
      const [name, value] = cookie.split("=");
      if (name === REGION_COOKIE_NAME && value) {
         try {
            return decodeURIComponent(value);
         } catch {
            return getRegionFromHostname();
         }
      }
   }
   return getRegionFromHostname();
};

export const setRegionCookie = (region) => {
   if (typeof document === "undefined" || !region) return;

   const maxAge = MAX_AGE_DAYS * 24 * 60 * 60;
   document.cookie = `${REGION_COOKIE_NAME}=${encodeURIComponent(region)}; Domain=${isDev ? ".playback-dev.com" : ".playbackhealth.com"}; path=/; max-age=${maxAge}`;
};

const redirectUserBasedOnRegion = (region) => {
   const { hostname, pathname, search } = window.location;
   let targetHost;

   if (region === "us") {
      if (hostname === euDev) targetHost = usDev;
      if (hostname === euProd) targetHost = usProd;
   } else if (region === "eu") {
      if (hostname === usDev) targetHost = euDev;
      if (hostname === usProd) targetHost = euProd;
   }

   if (targetHost) {
      window.location.replace(`https://${targetHost}${pathname}${search}`);
   }
};

export const selectRegion = (region) => {
   setRegionCookie(region);
   redirectUserBasedOnRegion(region);
};
